import { createFileRoute, Outlet } from "@tanstack/react-router";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/dashboard")({
  head: () => buildNoindexHead("Client Portal", "/dashboard"),
  component: () => <Outlet />,
});
